/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Modal, Spin, Progress } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import CheckboxTree from 'react-checkbox-tree';
import { ROUTER } from '../../../../constants/router';
import IconBack from '../../../../assets/Images/icons/icon-back';
import GlobalService from '../../../../services/Global.service';
import Collapse from './components/Collapse';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import {
    BorderOutlined,
    CaretDownOutlined,
    CaretRightOutlined,
    CheckSquareTwoTone,
    DatabaseOutlined,
    FileSyncOutlined,
    MinusSquareOutlined,
    MinusSquareTwoTone,
    PlusSquareOutlined,
} from '@ant-design/icons';
import DataFlowService from '../../../../services/DataFlow.service';
import useNotify from '../../../../context/Notification/useNotify';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import IconEmptySync from '../../../../assets/Images/icons/empty-sync';

function getItem(value, label, children) {
    return {
        value,
        children,
        label,
    };
}

const SyncData = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { businessProcessId, departmentId } = useParams();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [loading__, setLoading__] = useState(false);
    const [platform, setPlatform] = useState([]);
    const [valueSave, setValueSave] = useState();
    const [percent, setPercent] = useState(0);
    const [validate, setValidate] = useState(false);

    const notify = useNotify();

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);

    const onCancel = () => {
        navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=5`
        );
    };

    useEffect(() => {
        setLoading(true);

        const getDataHubPlatform = async () => {
            try {
                const { data } = await GlobalService.getDataHubPlatform();
                if (data?.resultData) {
                    setLoading(false);
                    setPlatform(data?.resultData);
                    let database = [];
                    data?.resultData?.map((list) =>
                        database.push({
                            platformId: list?.platFormId,
                            platformName: list?.platFormName,
                            platformSubName: list?.platFormSubName,
                        })
                    );
                    form.setFieldsValue({
                        database,
                    });
                }
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        };
        getDataHubPlatform();
    }, []);

    const onUploadProgress = ({ total, loaded }) => {
        const percent = Math.round((loaded / total) * 100).toFixed(2);
        setPercent(percent);
    };

    const onFinish = async () => {
        const database = valueSave?.database;
        const payload = {
            businessProcessId,
            departmentId,
            database,
        };
        setLoading__(true);
        setOpenConfirm(false);
        try {
            const { data } = await DataFlowService.syncData(
                payload,
                onUploadProgress
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('dataFlow.SuccessfullySyncData'),
                });
                setLoading__(false);
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=5`
                );
            } else {
                setLoading__(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            console.log(error);
            setLoading__(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(ROUTER.DS_INVENTORY.DATAFLOW);
                    }}
                >
                    <IconBack />
                </div>
                {t('Sync Data')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} / {t('Data Flow')} /{' '}
                    {t('Data Flow Details')} /{' '}
                </span>
                <span>{t('Sync Data')}</span>
            </div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={(values) => {
                    if (values) {
                        const array = values?.database
                            ?.filter((schema) => schema.schema)
                            .filter((schema) => schema.schema?.length > 0)
                            .map((database) => database?.schema);
                        if (Array.isArray(array) && array.length > 0) {
                            setValidate(false);
                            setOpenConfirm(true);
                            setValueSave(values);
                        } else {
                            setValidate(true);
                        }
                    }
                }}
            >
                <div className="bg-white w-full p-4 mt-4 rounded-xl">
                    <div className="flex justify-between items-center mb-4">
                        <div className="font-bold text-xl">
                            {t('dataFlow.ChooseDatabaseToSync')}{' '}
                        </div>
                        <div hidden={platform?.length === 0}>
                            <Button
                                size="large"
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-32 mr-3"
                                onClick={onCancel}
                            >
                                {t('common.Cancel')}
                            </Button>
                            <Button
                                size="large"
                                type="primary"
                                className="w-32"
                                htmlType="submit"
                            >
                                {t('common.Save')}
                            </Button>
                        </div>
                    </div>
                    <Spin spinning={loading}>
                        <div hidden={platform?.length === 0}>
                            <Form.List name="database">
                                {(fields) => (
                                    <>
                                        {fields.map(
                                            (
                                                { key, name, ...restField },
                                                i
                                            ) => (
                                                <div
                                                    key={key}
                                                    className="flex mt-1"
                                                >
                                                    <Form.Item
                                                        className="mb-2 w-full"
                                                        {...restField}
                                                        name={[name, 'schema']}
                                                    >
                                                        <TreeInput
                                                            platform={platform}
                                                            index={name}
                                                            validate={validate}
                                                            setValidate={
                                                                setValidate
                                                            }
                                                        />
                                                    </Form.Item>
                                                </div>
                                            )
                                        )}
                                        {validate && (
                                            <div className="text-error text-xs">
                                                {t('errorText.requiredField')}
                                            </div>
                                        )}
                                    </>
                                )}
                            </Form.List>
                        </div>
                        <div hidden={!loading && platform?.length > 0}>
                            <div className="col-span-2 flex-col text-center my-48">
                                <div>
                                    <IconEmptySync />
                                </div>
                                <div className="text-sm font-normal whitespace-pre-line">
                                    {t('dataFlow.emtyDataSync')}
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>
            </Form>
            <ModalConfirm
                // loading={loading__}
                title={t('dataFlow.ConfirmSync')}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onFinish}
                handelClose={() => setOpenConfirm(false)}
            />
            <Modal
                open={loading__}
                onCancel={() => setLoading__(false)}
                centered
                footer={false}
                closable={false}
                className="_modal"
            >
                <Progress
                    strokeColor={{
                        '0%': '#E6E6FA',
                        '100%': '#7D7AFF',
                    }}
                    percent={percent}
                    showInfo={false}
                />
                <p className="text-[#65707A] text-tiny font-semibold text-center ">
                    {t('dataFlow.SyncYourData')}...
                </p>
            </Modal>
        </div>
    );
};

const TreeInput = ({ onChange, index, platform, validate, setValidate }) => {
    const [loading, setLoading] = useState(true);
    const [treeData, setTreeData] = useState([]);
    const [checked, setChecked] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [schema, setSchema] = useState([]);
    const triggerChange = (changedValue) => {
        onChange?.(changedValue);
    };

    useEffect(() => {
        triggerChange(schema);
        setValidate(false);
    }, [schema]);

    useEffect(() => {
        const getDataHubDb = async () => {
            setLoading(true);
            try {
                const { data } = await GlobalService.getDataHubDb(
                    platform[index]?.platFormId
                );
                if (data?.resultData) {
                    setLoading(false);
                    generatorTreeData(data?.resultData);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.log(error);
            }
        };

        getDataHubDb();
    }, [platform[index]?.platFormId]);

    const generatorTreeData = (db) => {
        let defaultExpandedKeys = [];
        const treeData = db.map((d) => {
            const children = d?.tables?.map((table) =>
                getItem(table?.tableId, table?.tableName)
            );
            defaultExpandedKeys.push(d?.schemaId);
            return getItem(d?.schemaId, d?.schemaName, children);
        });
        setTreeData(treeData);
    };

    const onCheck = (checked, info) => {
        setChecked(checked);
        // isChecked
        if (info.checked) {
            if (info.isParent) {
                const checkHave = schema.find(
                    (schema) => schema.schemaId === info?.value
                );
                if (checkHave) {
                    const updateState = schema.map((obj) => {
                        if (obj.schemaId === info?.value) {
                            return {
                                ...obj,
                                table: info?.children.map((list) => {
                                    return {
                                        tableId: list?.value,
                                        tableName: list?.label,
                                    };
                                }),
                            };
                        }
                        return obj;
                    });
                    setSchema(updateState);
                    // triggerChange(updateState);
                } else {
                    const newSchema = {
                        schemaId: info?.value,
                        schemaName: info?.label,
                        table: info?.children.map((list) => {
                            return {
                                tableId: list?.value,
                                tableName: list?.label,
                            };
                        }),
                    };
                    setSchema([...schema, newSchema]);
                    // triggerChange([...schema, newSchema]);
                }
            } else {
                const checkHave = schema.find(
                    (schema) => schema.schemaId === info?.parent?.value
                );
                if (checkHave) {
                    const updateState = schema.map((obj) => {
                        if (obj.schemaId === info?.parent?.value) {
                            const newTable = {
                                tableId: info?.value,
                                tableName: info?.label,
                            };
                            const newValue = [...obj?.table, newTable];
                            return {
                                ...obj,
                                table: [
                                    ...new Map(
                                        newValue.map((item) => [
                                            JSON.stringify(item),
                                            item,
                                        ])
                                    ).values(),
                                ],
                            };
                        }
                        return obj;
                    });
                    setSchema(updateState);
                    // triggerChange(updateState);
                } else {
                    const newSchema = {
                        schemaId: info?.parent?.value,
                        schemaName: info?.parent?.label,
                        table: [
                            {
                                tableId: info?.value,
                                tableName: info?.label,
                            },
                        ],
                    };
                    setSchema([...schema, newSchema]);
                    // triggerChange([...schema, newSchema]);
                }
            }
        } else {
            if (info.isParent) {
                const updateState = schema.filter(
                    (obj) => obj.schemaId !== info?.value
                );
                setSchema(updateState);
                // triggerChange(updateState);
            } else {
                const checkHave = schema.find(
                    (schema) => schema.schemaId === info?.parent?.value
                );
                if (checkHave) {
                    const updateState = schema.map((obj) => {
                        if (obj.schemaId === info?.parent?.value) {
                            return {
                                ...obj,
                                table: obj?.table.filter(
                                    (table) => table.tableId !== info?.value
                                ),
                            };
                        }
                        return obj;
                    });
                    setSchema(updateState);
                    // triggerChange(updateState);
                } else {
                    const newSchema = {
                        schemaId: info?.parent?.value,
                        schemaName: info?.parent?.label,
                        table: [
                            {
                                tableId: info?.value,
                                tableName: info?.label,
                            },
                        ],
                    };
                    setSchema([...schema, newSchema]);
                    // triggerChange([...schema, newSchema]);
                }
            }
        }
    };

    return (
        <Collapse
            title={platform[index].platFormName}
            key={platform[index]?.platFormId}
            validate={validate}
        >
            <Spin spinning={loading}>
                <CheckboxTree
                    nodes={treeData}
                    showExpandAll
                    checked={checked}
                    expanded={expanded}
                    onCheck={onCheck}
                    icons={{
                        check: <CheckSquareTwoTone />,
                        uncheck: <BorderOutlined />,
                        halfCheck: <MinusSquareTwoTone />,
                        expandClose: <CaretRightOutlined />,
                        expandOpen: <CaretDownOutlined />,
                        expandAll: <PlusSquareOutlined />,
                        collapseAll: <MinusSquareOutlined />,
                        parentClose: <DatabaseOutlined />,
                        parentOpen: <DatabaseOutlined />,
                        leaf: <FileSyncOutlined />,
                    }}
                    onExpand={(expanded) => setExpanded(expanded)}
                />
            </Spin>
        </Collapse>
    );
};

export default SyncData;
